import React from 'react';
import { Tag } from 'antd';

import theme from 'utils/theme';

const TransactionStatusTag = props => {
  const styleObj = {};
  if (props.is_charged && props.is_confirmed && props.is_booked) {
    styleObj.label = 'Success';
    styleObj.color = theme.green;
  }
  if (!props.is_charged && !props.is_confirmed && props.is_booked) {
    styleObj.label = 'Wait for confirmation';
    styleObj.color = theme.red;
  }
  if (!props.is_charged && props.is_confirmed && props.is_booked) {
    styleObj.label = 'Not charged';
    styleObj.color = theme.red;
  }
  if (!props.is_charged && !props.is_confirmed && !props.is_booked) {
    styleObj.label = 'Not booked';
    styleObj.color = theme.red;
  }
  return (
    <Tag color={styleObj.color}>{styleObj.label}</Tag>
  );
};

export default TransactionStatusTag;



// WEBPACK FOOTER //
// ./src/components/Transaction/TransactionStatusTag.js